/**
 * @generated SignedSource<<c753ecb337a1d1138dbceafd7e7f672c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type EditorCloseButtonGetDraftParentFragment$data = {
  readonly __typename: "Content";
  readonly ancestors: ReadonlyArray<{
    readonly id: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly id: string | null | undefined;
  readonly " $fragmentType": "EditorCloseButtonGetDraftParentFragment";
};
export type EditorCloseButtonGetDraftParentFragment$key = {
  readonly " $data"?: EditorCloseButtonGetDraftParentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorCloseButtonGetDraftParentFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "EditorCloseButtonGetDraftParentFragment",
  "selections": [
    (v0/*: any*/),
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "ancestors",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "2b05313527c3eb54a3e1e06657506abb";

export default node;
